module.exports = __webpack_public_path__ + "assets/00290e39898c7fac3a26b5a20535b5cb.png";